import { render, staticRenderFns } from "./tertiary-action-button.vue?vue&type=template&id=45813577"
import script from "./tertiary-action-button.vue?vue&type=script&lang=js"
export * from "./tertiary-action-button.vue?vue&type=script&lang=js"
import style0 from "./tertiary-action-button.vue?vue&type=style&index=0&id=45813577&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports